import React from "react";
import Link from "next/link";
import Breadcrumb from "react-bootstrap/lib/Breadcrumb";
import style from "./main.module.scss";

interface BreadcrumbItem {
  link: string;
  name: string;
  className?: string;
}

type BreadcrumbItems = Array<BreadcrumbItem>;
interface BreadcrumbContainerProps {
  items: BreadcrumbItems;
  className: string;
  lastItemActive?: boolean;
}

const BreadcrumbContainer = (props: BreadcrumbContainerProps) => {
  const { className = "", items, lastItemActive = true } = props;
  const renderBreadCrumbItem = (item, index) => {
    const isActive = lastItemActive && index === items.length - 1;
    if (isActive) {
      return (
        <Breadcrumb.Item
          {...Breadcrumb.Item.defaultProps}
          active={isActive}
          key={`breadcrumb-${index}-${item.name}`}
          className={`breadcrumb-item ${style.uiBreadcrumbItem}`}
        >
          <span>{item.name}</span>
        </Breadcrumb.Item>
      );
    } else {
      return (
        <li
          key={`breadcrumb-${index}-${item.name}`}
          className={`breadcrumb-item ${style.uiBreadcrumbItem}`}
        >
          <Link href={item.link} prefetch={false}>
            {item.name}
          </Link>
        </li>
      );
    }
  };
  return (
    <Breadcrumb className={`${className} ${style.uiBreadcrumb}`}>
      {items.map((item, index) => renderBreadCrumbItem(item, index))}
    </Breadcrumb>
  );
};

export default BreadcrumbContainer;
